import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { HomePage } from '@/pages/HomePage';
import { AboutPage } from '@/pages/AboutPage';
import { BloodGroupsPage } from '@/pages/BloodGroupsPage';
import { GalleryPage } from '@/pages/GalleryPage';
import { DonorsPage } from '@/pages/DonorsPage';
import { CampsPage } from '@/pages/CampsPage';
import { ContactPage } from '@/pages/ContactPage';
import './App.css';

function App() {
  const BASE_URL = import.meta.env.BASE_URL;
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/blood-groups" element={<BloodGroupsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/donors" element={<DonorsPage />} />
            <Route path="/camps" element={<CampsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        {/* Footer */}
        <footer className="bg-neutral-900 text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="flex flex-col">
                <Link to="/" className="mb-4">
                  <img
                    src={`${BASE_URL}images/sri-balaji_logo.png`}
                    alt="Sri Balaji Blood Centre"
                    className="h-16 w-auto"
                    decoding="async"
                    loading="lazy"
                  />
                </Link>
                <p className="text-body text-neutral-300 mb-4">
                  Dedicated to providing safe, reliable blood products and exceptional service to our community.
                </p>
                <div className="mt-auto">
                  <div className="flex items-center space-x-2">
                    <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold">B</span>
                    </div>
                    <span className="text-small text-neutral-400">Serving the community since 6th August 2009</span>
                  </div>
                </div>
              </div>
              <div>
                <h4 className="text-body font-semibold mb-4">Quick Links</h4>
                <ul className="space-y-2">
                  <li><Link to="/contact" className="text-body text-neutral-300 hover:text-white transition-colors">Become a Donor</Link></li>
                  <li><Link to="/about" className="text-body text-neutral-300 hover:text-white transition-colors">About Us</Link></li>
                  <li><Link to="/camps" className="text-body text-neutral-300 hover:text-white transition-colors">Host a Blood Drive</Link></li>
                  <li><Link to="/blood-groups" className="text-body text-neutral-300 hover:text-white transition-colors">Blood Types</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="text-body font-semibold mb-4">Contact Info</h4>
                <div className="space-y-2 text-body text-neutral-300">
                  <p>D.No.16-2-701/5/1/C, 4th Floor</p>
                  <p>Susrutha Hospital Buildings</p>
                  <p>Opp. Malakpet Market, Pillar No. 1448</p>
                  <p>Hyderabad, TS-36</p>
                  <p>Phone: 040-24572195, 24577760</p>
                  <p>Mobile: 9949237760</p>
                </div>
              </div>
              <div>
                <h4 className="text-body font-semibold mb-4">Hours</h4>
                <div className="space-y-2 text-body text-neutral-300">
                  <p>Mon - Sat: 10:00 AM - 6:00 PM</p>
                  <p>Sunday: Closed (Sunday holiday)</p>
                  <p className="text-semantic-warning">Hours may vary on public holidays</p>
                </div>
              </div>
            </div>
            <div className="border-t border-neutral-700 mt-12 pt-8 text-center">
              <p className="text-body text-neutral-400">
                &copy; 2025 Sri Balaji Blood Center. All rights reserved. | Licensed by State Health Department
              </p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
